var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    d: "M11.875 1.66669C12.1914 1.66669 12.4529 1.90182 12.4943 2.20688L12.5 2.29169V4.16669H16.875C17.2202 4.16669 17.5 4.44651 17.5 4.79169V17.7084C17.5 18.0535 17.2202 18.3334 16.875 18.3334H14.375C14.0298 18.3334 13.75 18.0535 13.75 17.7084V15.4167H12.0833V17.7084C12.0833 18.0535 11.8035 18.3334 11.4583 18.3334H8.95833C8.61316 18.3334 8.33333 18.0535 8.33333 17.7084V4.79169C8.33333 4.44651 8.61316 4.16669 8.95833 4.16669H11.25V2.91669H3.75V17.7084C3.75 18.0535 3.47018 18.3334 3.125 18.3334C2.80859 18.3334 2.54709 18.0982 2.50571 17.7932L2.5 17.7084V2.29169C2.5 1.97527 2.73513 1.71378 3.04019 1.67239L3.125 1.66669H11.875ZM16.25 5.41669H9.58333V17.0834H10.8333V14.7917C10.8333 14.4465 11.1132 14.1667 11.4583 14.1667H14.375C14.7202 14.1667 15 14.4465 15 14.7917V17.0834H16.25V5.41669ZM6.66667 14.1667V15.8334H5V14.1667H6.66667ZM12.5 11.6667V13.3334H10.8333V11.6667H12.5ZM15 11.6667V13.3334H13.3333V11.6667H15ZM6.66667 11.6667V13.3334H5V11.6667H6.66667ZM12.5 9.16669V10.8334H10.8333V9.16669H12.5ZM15 9.16669V10.8334H13.3333V9.16669H15ZM6.66667 9.16669V10.8334H5V9.16669H6.66667ZM6.66667 6.66669V8.33335H5V6.66669H6.66667ZM12.5 6.66669V8.33335H10.8333V6.66669H12.5ZM15 6.66669V8.33335H13.3333V6.66669H15ZM6.66667 4.16669V5.83335H5V4.16669H6.66667Z",
    fill: "#9B9DAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.c99501e13e070a001ed2e69a9e29687d.svg";
export { ForwardRef as ReactComponent };